"use client";

import { memo } from "react";
import { Check } from "lucide-react";
import clsx from "clsx";

type StepType = "default" | "in_progress" | "complete";

interface StepProps {
  count: number;
  title: string;
  type: StepType;
  className?: string;
}

const Step = memo(({ count, title, type, className }: StepProps) => {
  const isInProgress = type === "in_progress";
  const isComplete = type === "complete";

  return (
    <div className={clsx("flex items-center gap-2", className)}>
      {/* Circle */}
      <div
        className={`flex items-center justify-center w-5 h-5 rounded-full border text-[10px] font-semibold
          ${isInProgress ? "bg-brand border-brand text-white" : ""}
          ${isComplete ? "bg-active border-active text-white" : ""}
          ${type === "default" ? "bg-white border-gray-300 text-gray-400" : ""}
        `}
      >
        {isComplete ? <Check size={10} /> : count}
      </div>

      {/* Title */}
      <span
        className={`text-sm font-medium ${
          isInProgress || isComplete ? "text-black" : "text-gray-500"
        }`}
      >
        {title}
      </span>
    </div>
  );
});

Step.displayName = "Step";

export default Step;
